define.alias("ember-math-helpers/helpers/atan", "calendar/helpers/atan");